var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWasd = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 56,
    viewBox: "0 0 81 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.951 29.274H4.181a3.107 3.107 0 0 0-3.109 3.105v19.516A3.107 3.107 0 0 0 4.182 55h17.77c1.716 0 3.109-1.39 3.109-3.105V32.38a3.107 3.107 0 0 0-3.11-3.105Z",
    stroke: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.711 31.1H4.422c-.859 0-1.555.695-1.555 1.552v17.605c0 .858.696 1.553 1.555 1.553h17.289c.859 0 1.555-.695 1.555-1.553V32.653c0-.857-.696-1.552-1.555-1.552Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.106 43.383h-2.964l-.49 1.415H9.083l2.676-7.44h1.738l2.676 7.44h-1.578l-.49-1.415ZM13.7 42.19l-1.076-3.108-1.077 3.108H13.7Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.494 29.274h-17.77a3.107 3.107 0 0 0-3.109 3.105v19.516A3.107 3.107 0 0 0 31.725 55h17.769c1.717 0 3.11-1.39 3.11-3.105V32.38a3.107 3.107 0 0 0-3.11-3.105Z",
    stroke: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.254 31.1H31.965c-.859 0-1.555.695-1.555 1.552v17.605c0 .858.696 1.553 1.555 1.553h17.289c.859 0 1.555-.695 1.555-1.553V32.653c0-.857-.696-1.552-1.555-1.552Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.666 44.873a3.58 3.58 0 0 1-1.408-.266 2.306 2.306 0 0 1-.98-.767 2.015 2.015 0 0 1-.374-1.181h1.6c.02.305.128.546.32.724.198.177.468.266.81.266.348 0 .622-.082.82-.245a.829.829 0 0 0 .3-.66.755.755 0 0 0-.203-.543 1.355 1.355 0 0 0-.512-.33 6.995 6.995 0 0 0-.832-.277 9.945 9.945 0 0 1-1.183-.415 2.192 2.192 0 0 1-.779-.628c-.213-.284-.32-.66-.32-1.128 0-.44.11-.824.331-1.15.22-.326.53-.575.928-.745a3.32 3.32 0 0 1 1.364-.266c.768 0 1.39.188 1.866.564.483.369.75.887.8 1.554h-1.642a.83.83 0 0 0-.33-.628c-.2-.17-.466-.255-.8-.255-.292 0-.526.074-.704.223-.17.15-.256.366-.256.65a.7.7 0 0 0 .192.5c.135.128.299.234.49.32.2.077.477.17.832.276a8.69 8.69 0 0 1 1.184.426c.305.142.568.354.788.638.22.284.331.657.331 1.118 0 .398-.103.767-.31 1.107-.205.34-.507.614-.905.82-.398.199-.871.298-1.418.298Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.494 0h-17.77a3.107 3.107 0 0 0-3.109 3.105V22.62a3.107 3.107 0 0 0 3.11 3.105h17.769c1.717 0 3.11-1.39 3.11-3.105V3.105A3.107 3.107 0 0 0 49.494 0Z",
    stroke: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.254 1.825H31.965c-.859 0-1.555.695-1.555 1.553v17.605c0 .857.696 1.552 1.555 1.552h17.289c.859 0 1.555-.695 1.555-1.552V3.378c0-.858-.696-1.553-1.555-1.553Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m45.386 8.094-2.08 7.43h-1.758l-1.397-5.29-1.46 5.29-1.75.011-2.004-7.44h1.6l1.311 5.769 1.514-5.77h1.663l1.429 5.738 1.322-5.738h1.61Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.035 29.274h-17.77a3.107 3.107 0 0 0-3.109 3.105v19.516A3.107 3.107 0 0 0 59.266 55h17.769c1.717 0 3.11-1.39 3.11-3.105V32.38a3.107 3.107 0 0 0-3.11-3.105Z",
    stroke: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.797 31.1h-17.29c-.858 0-1.554.695-1.554 1.552v17.605c0 .858.696 1.553 1.555 1.553h17.289c.859 0 1.555-.695 1.555-1.553V32.653c0-.857-.696-1.552-1.555-1.552Z",
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.222 37.368c.782 0 1.468.153 2.058.458a3.223 3.223 0 0 1 1.376 1.31c.326.56.49 1.213.49 1.958 0 .745-.163 1.398-.49 1.959a3.26 3.26 0 0 1-1.376 1.288c-.59.305-1.276.457-2.058.457h-2.6v-7.43h2.6Zm-.053 6.164c.782 0 1.386-.213 1.813-.639.426-.426.64-1.026.64-1.799 0-.774-.214-1.377-.64-1.81-.427-.44-1.031-.66-1.813-.66h-1.055v4.908h1.055Z",
    fill: "#fff"
  })));
};
export { SvgWasd as ReactComponent };